import { WebsiteBlock, WebsiteBlockType } from "../interfaces/WebsiteBlock";
import { createDefaultNavbarBlock } from "./navbarDefaults";

export interface BlockTypeDefinition {
  type: WebsiteBlockType;
  labelKey: string;
  icon: string;
  defaultBlock: Partial<import("../interfaces/WebsiteBlock").WebsiteBlock>;
}

export const BLOCK_TYPES: BlockTypeDefinition[] = [
  {
    type: "navbar",
    labelKey: "app.websitePage.blocks.navbar",
    icon: "bars",
    defaultBlock: createDefaultNavbarBlock(),
  },
  {
    type: "header",
    labelKey: "app.websitePage.blocks.header",
    icon: "heading",
    defaultBlock: { type: "header", level: 2, content: "Encabezado" },
  },
  {
    type: "text",
    labelKey: "app.websitePage.blocks.text",
    icon: "align-left",
    defaultBlock: { type: "text", content: "Escribe tu texto aquí..." },
  },
  {
    type: "image",
    labelKey: "app.websitePage.blocks.image",
    icon: "image",
    defaultBlock: { type: "image", src: "https://via.placeholder.com/800x400", alt: "Imagen" },
  },
  {
    type: "button",
    labelKey: "app.websitePage.blocks.button",
    icon: "hand-pointer",
    defaultBlock: { type: "button", label: "Click aquí", href: "#", backgroundColor: "#4361ee", color: "#fff" },
  },
  {
    type: "hero",
    labelKey: "app.websitePage.blocks.hero",
    icon: "star",
    defaultBlock: {
      type: "hero",
      title: "Título principal",
      subtitle: "Subtítulo descriptivo",
      backgroundColor: "#4361ee",
      buttonLabel: "Comenzar",
      buttonHref: "#",
    },
  },
  {
    type: "columns",
    labelKey: "app.websitePage.blocks.columns",
    icon: "columns",
    defaultBlock: {
      type: "columns",
      columns: [
        { blocks: [{ id: "c1", type: "text", content: "Columna 1" }] },
        { blocks: [{ id: "c2", type: "text", content: "Columna 2" }] },
      ],
    },
  },
  {
    type: "gallery",
    labelKey: "app.websitePage.blocks.gallery",
    icon: "images",
    defaultBlock: {
      type: "gallery",
      images: [
        { src: "https://via.placeholder.com/300x200", alt: "Imagen 1" },
        { src: "https://via.placeholder.com/300x200", alt: "Imagen 2" },
        { src: "https://via.placeholder.com/300x200", alt: "Imagen 3" },
      ],
    },
  },
  {
    type: "video",
    labelKey: "app.websitePage.blocks.video",
    icon: "video",
    defaultBlock: { type: "video", embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ" },
  },
  {
    type: "testimonials",
    labelKey: "app.websitePage.blocks.testimonials",
    icon: "quote-right",
    defaultBlock: {
      type: "testimonials",
      items: [
        { quote: "Excelente servicio.", author: "Cliente 1", role: "CEO" },
        { quote: "Muy recomendado.", author: "Cliente 2", role: "Director" },
      ],
    },
  },
  {
    type: "faq",
    labelKey: "app.websitePage.blocks.faq",
    icon: "question-circle",
    defaultBlock: {
      type: "faq",
      items: [
        { question: "¿Pregunta frecuente 1?", answer: "Respuesta aquí." },
        { question: "¿Pregunta frecuente 2?", answer: "Respuesta aquí." },
      ],
    },
  },
  {
    type: "cta",
    labelKey: "app.websitePage.blocks.cta",
    icon: "bullhorn",
    defaultBlock: {
      type: "cta",
      title: "¿Listo para empezar?",
      subtitle: "Contáctanos hoy",
      backgroundColor: "#1a1a2e",
      color: "#fff",
      buttonLabel: "Contactar",
      buttonHref: "#",
    },
  },
  {
    type: "footer",
    labelKey: "app.websitePage.blocks.footer",
    icon: "window-minimize",
    defaultBlock: { type: "footer", content: "© Tu Empresa. Todos los derechos reservados." },
  },
  {
    type: "contact-form",
    labelKey: "app.websitePage.blocks.contactForm",
    icon: "wpforms",
    defaultBlock: { type: "contact-form" },
  },
  {
    type: "spacer",
    labelKey: "app.websitePage.blocks.spacer",
    icon: "arrows-alt-v",
    defaultBlock: { type: "spacer", height: "48px" },
  },
  {
    type: "html-page",
    labelKey: "app.websitePage.blocks.htmlPage",
    icon: "code",
    defaultBlock: { type: "html-page", html: "" },
  },
];

export const PAGE_TEMPLATES = [
  { id: "blank", labelKey: "app.websitePage.templates.blank" },
  { id: "business", labelKey: "app.websitePage.templates.business" },
  { id: "landing", labelKey: "app.websitePage.templates.landing" },
  { id: "realestate", labelKey: "app.websitePage.templates.realestate" },
  { id: "artisan", labelKey: "app.websitePage.templates.artisan" },
  { id: "custom-code", labelKey: "app.websitePage.templates.customCode" },
  { id: "custom-ai", labelKey: "app.websitePage.templates.customAi" },
];
